import { render, staticRenderFns } from "./WeightTrackerComponent.vue?vue&type=template&id=9989a2ba&"
import script from "./WeightTrackerComponent.vue?vue&type=script&lang=ts&"
export * from "./WeightTrackerComponent.vue?vue&type=script&lang=ts&"
import style0 from "./WeightTrackerComponent.vue?vue&type=style&index=0&id=9989a2ba&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports